<div class="PGChat-CurrentChannel">
    @if (showHeader) {
        <div class="PGChat-CurrentChannel-Header p-1 border-bottom">
            <div class="PGChat-CurrentChannel-Header-Title">
                <ng-content select="[channelTitle]"></ng-content>
            </div>
            <div class="PGChat-CurrentChannel-Header-Actions">
                <ng-content select="[channelActions]"></ng-content>
            </div>
        </div>
    }
    <div class="PGChat-CurrentChannel-Content">
        @if (ready) {
            <div class="PGChat-CurrentChannel-Content-Main">
                <div #messagesElement class="PGChat-CurrentChannel-Content-Main-Messages py-1 px-2">
                    @for (message of messages; track message; let i = $index) {
                        @if (hasMessageDate(messages, i)) {
                            <div class="text-muted border-bottom mb-2">
                                <small class="text-muted">{{ getMessageDate(message) }}</small>
                            </div>
                        }
                        <div class="mb-2">
                            @if (hasMessageUserAndTime(messages, i)) {
                                <div>
                                    <b class="me-2">{{ resolveUserName(message.from) }}</b>
                                    <small class="text-muted">{{ getMessageTime(message) }}</small>
                                </div>
                            }
                            @if (message.content != null && message.content != '') {
                                <div class="PGChat-CurrentChannel-Content-Main-Messages-Content">
                                    <span>{{ message.content }}</span>
                                </div>
                            }
                            @if (message.data != null) {
                                <div>
                                    @if (message.data.type == 'attachment') {
                                        <div>
                                            <a target="_blank" [href]="message.data.url | safe:'url'">
                                                <i class="fa-regular fa-paperclip"></i>
                                                <span class="ms-1">{{message.data.name}}</span>
                                            </a>
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    }
                </div>
                <div class="PGChat-CurrentChannel-Content-Main-Input border-top">
                    @if (typing != null) {
                        <div class="PGChat-CurrentChannel-Content-Main-Input-Typing small bg-white border rounded px-1">
                            <span class="PGChat-CurrentChannel-Content-Main-Input-Typing-Icon me-1">
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle"></i>
                                <i class="fa fa-circle"></i>
                            </span>
                            @for (item of typing | keyvalue; track item) {
                                <span>{{ resolveUserName(item.key) }}</span>
                            }
                        </div>
                    }
                    <div class="d-flex">
                        <input class="form-control border-0" [(ngModel)]="editMessageText" (keyup)="onEditMessageTextKeyUp($event)" [disabled]="disabled"/>
                        @if (allowAttachments) {
                            <div class="border-start">
                                <button type="button" class="btn btn-link PGChat-CurrentChannel-Content-Main-Input-Attachment" [disabled]="disabled">
                                    <i class="fa-regular fa-paperclip m-0"></i>
                                    <app-pg-upload-button [overlay]="true" [disabled]="disabled" (setFiles)="onFiles($event)"></app-pg-upload-button>
                                </button>
                            </div>
                        }
                    </div>
                </div>
            </div>
        }
    </div>
</div>
